// WantsCourtToggle — ActivityWizard Steg 3 (delspår 3d). "Vill du boka bana?" Ja/Nej
// (PadelMates IMG_1215 + samma stil som synlighet-toggeln i 3b). Default Ja (väg B).
// Nej = väg A (ingen bana). Väg C (har redan bokat) byggs EJ (Lesson 48 — inget tredje val).

import { cn } from "@/lib/utils";
import { useTranslation } from "react-i18next";

interface WantsCourtToggleProps {
  value: boolean;
  onChange: (value: boolean) => void;
}

export default function WantsCourtToggle({ value, onChange }: WantsCourtToggleProps) {
  const { t } = useTranslation("admin");
  return (
    <div className="grid grid-cols-2 gap-1 rounded-2xl border border-border/60 bg-muted/50 p-1">
      {([true, false] as const).map((v) => (
        <button
          key={String(v)}
          type="button"
          aria-pressed={value === v}
          data-testid={`wants-court-${v ? "yes" : "no"}`}
          onClick={() => onChange(v)}
          className={cn(
            "rounded-xl border border-transparent p-2.5 text-sm font-medium transition-colors",
            value === v
              ? "livfull-pill-selected"
              : "text-muted-foreground hover:text-foreground",
          )}
        >
          {v
            ? t("activityWizard.step3.wantsCourtYes", { defaultValue: "Ja" })
            : t("activityWizard.step3.wantsCourtNo", { defaultValue: "Nej" })}
        </button>
      ))}
    </div>
  );
}
